import React from "react";

const FlashcardOptions = React.memo(({
  vocabularyList,
  getDueWords,
  getReviewPriority,
  startQuick4Review,
  setFlashcardModalStep
}) => {
  return (
    <div className="space-y-4">
      {/* Quick Review */}
      <div className="bg-black/80 border border-green-400/60 rounded-xl p-6 shadow-neon-green mb-6">
        <h3 className="font-black font-mono text-green-400 mb-4 flex items-center gap-3">
          QUICK REVIEW
        </h3>
        <button
          onClick={startQuick4Review}
          className="flex items-center gap-3 px-6 py-4 bg-black/80 border border-green-400/50 rounded-xl text-green-100 font-mono font-bold hover:border-green-400 hover:shadow-neon-green transition-all duration-300 backdrop-blur-sm w-full"
          disabled={
            getDueWords().length === 0 &&
            vocabularyList.filter(
              (word) =>
                getReviewPriority(word) === "urgent" ||
                getReviewPriority(word) === "warning"
            ).length === 0
          }
        >
          <div className="text-left">
            <div className="text-sm">SCIENTIFIC QUICK REVIEW</div>
            <div className="text-xs text-green-400">
              {">"} Optimized learning protocol
            </div>
          </div>
        </button>
      </div>

      {/* Custom Selection */}
      <div className="bg-black/80 border border-cyan-400/60 rounded-xl p-6 shadow-neon-cyan">
        <h3 className="font-black font-mono text-cyan-400 mb-4 flex items-center gap-3">
          CUSTOM SELECTION
        </h3>
        <button
          onClick={() => setFlashcardModalStep("select")}
          className="flex items-center gap-3 px-6 py-4 bg-black/80 border border-cyan-400/50 rounded-xl text-cyan-100 font-mono font-bold hover:border-cyan-400 hover:shadow-neon-cyan transition-all duration-300 backdrop-blur-sm w-full"
          disabled={vocabularyList.length === 0}
        >
          <div className="text-left">
            <div className="text-sm">SELECT VOCABULARY TO TEST</div>
            <div className="text-xs text-cyan-400">
              {">"} Choose specific words for review
            </div>
          </div>
        </button>
      </div>
    </div>
  );
});

export default FlashcardOptions; 